<template>
  <hm-content title="">
    <el-form
      ref="ruleForm"
      :model="ruleForm"
      :rules="rules"
      label-width="170px"
    >
      <el-form-item label="金豆获取名称：" prop="name">
        <el-input
          v-model.trim="ruleForm.name"
          size="small"
          clearable
          maxlength="25"
          placeholder="请输入金豆获取名称"
          :disabled="
            type === 'detail' || timeStatus === 'going' || timeStatus === 'end'
          "
        ></el-input>
      </el-form-item>
      <el-form-item label="金豆获取方式" prop="sendWayType">
        <el-radio-group
          v-model="ruleForm.sendWayType"
          :disabled="
            type === 'detail' || timeStatus === 'going' || timeStatus === 'end'
          "
        >
          <!-- <el-radio label="online">线上交易</el-radio> -->
          <el-radio label="offline">线下交易</el-radio>
          <el-radio label="syncIntegral">同步积分</el-radio>
        </el-radio-group>
      </el-form-item>
      <el-form-item v-if="ruleForm.sendWayType === 'offline'" label="金豆获取比例" prop="exchangeRatio">
        <el-input
          :disabled="
            type === 'detail' || timeStatus === 'going' || timeStatus === 'end'
          "
          v-model.trim="ruleForm.exchangeRatio"
          maxlength="20"
          clearable
          size="small"
          placeholder="请输入比例"
          @input="filterGt0OrFixed0('exchangeRatio')"
        ></el-input>
        %
        <div class="form-item-tip">
          金豆获取数量=订单实付金额*金豆获取比例,获取金豆数量取整,小数点后不计入
        </div>
      </el-form-item>
      <el-form-item v-if="ruleForm.sendWayType === 'offline'" label="金豆获取订单门槛" prop="levelMin">
        <el-input
          :disabled="type === 'detail'"
          v-model.trim="ruleForm.levelMin"
          maxlength="20"
          clearable
          size="small"
          placeholder="请输入金额"
          @input="filterGt0OrFixed2('levelMin')"
        ></el-input>
        元
        <div class="form-item-tip">
          订单金额达到多少才会触发获取金豆机制
        </div>
      </el-form-item>
      <el-form-item label="关联金豆" prop="ruleId">
        <el-select
          :disabled="
            type === 'detail' || timeStatus === 'going' || timeStatus === 'end'
          "
          size="small"
          clearable
          placeholder="选择关联金豆"
          v-model="ruleForm.ruleId"
          class="mr10"
          filterable
        >
          <el-option
            v-for="(item, i) in ruleList"
            :key="i"
            :label="item.name"
            :value="item.ruleId"
          ></el-option>
        </el-select>
      </el-form-item>
      <el-form-item v-if="ruleForm.sendWayType === 'offline'" label="获取金豆会员群组" prop="groupId">
        <el-select
          :disabled="
            type === 'detail' || timeStatus === 'going' || timeStatus === 'end'
          "
          clearable
          filterable
          size="small"
          v-model="ruleForm.groupId"
          placeholder="请选择会员群组"
        >
          <el-option
            :label="v.groupAppellation"
            :value="v.groupId"
            v-for="(v, i) in memberGroupList"
            :key="i"
          ></el-option>
        </el-select>
      </el-form-item>
      <el-form-item v-if="ruleForm.sendWayType === 'offline'" label="获取金豆时间" prop="applyDate">
        <el-date-picker
          :disabled="
            type === 'detail' || timeStatus === 'going' || timeStatus === 'end'
          "
          v-model="ruleForm.applyDate"
          @change="applyDateChange"
          type="datetimerange"
          align="right"
          ref="applyDatePicker"
          :default-time="['00:00:00', '23:59:59']"
          start-placeholder="开始时间"
          end-placeholder="结束时间"
          value-format="yyyy-MM-dd HH:mm:ss"
          size="small"
          class="mr10"
        ></el-date-picker>
      </el-form-item>
      <el-form-item v-if="ruleForm.sendWayType === 'offline'" label="金豆获取特殊比例时段" prop="specialStatus">
        <el-radio-group
          v-model="ruleForm.specialStatus"
          :disabled="
            type === 'detail' || timeStatus === 'going' || timeStatus === 'end'
          "
        >
          <el-radio label="no">关闭</el-radio>
          <el-radio label="yes">开启</el-radio>
        </el-radio-group>
        <span class="ml20" v-if="type !== 'add'">
          <el-button
            type="text"
            size="small"
            class="blue"
            @click="detailHistory"
            >查看历史记录</el-button
          >
        </span>
      </el-form-item>
      <div v-if="ruleForm.specialStatus === 'yes'">
        <el-form-item
          v-for="(item, i) in ruleForm.specialTimeModelList"
          :key="i"
          :disabled="
            type === 'detail' || timeStatus === 'going' || timeStatus === 'end'
          "
        >
          <div class="flex item-center">
            <el-radio
              v-model="ruleForm.isFirst"
              :label="i"
              :disabled="type === 'detail'"
              style="font-weight:700;margin-bottom:30px"
              >优先获取
            </el-radio>
            <el-form-item
              label="主题名称"
              :prop="'specialTimeModelList.' + i + '.name'"
              :rules="rules.name"
              label-width="80px"
              style="margin-bottom:30px"
            >
              <el-input
                :disabled="type === 'detail' || !!item.sendId"
                v-model.trim="item.name"
                clearable
                size="small"
                style="width:330px"
                maxlength="30"
                placeholder="请输入主题名称，例：618年中大促双倍积分"
              ></el-input>
            </el-form-item>
            <div v-if="type !== 'detail'">
              <div
                class="add-wrapper flex flex-center"
                @click="addItem"
                v-if="i === 0"
                style="margin-bottom:30px"
              >
                <span class="hmicon icon-hao pointer"></span>
              </div>
              <div
                v-if="i !== 0 && !item.sendId"
                class="minus-wrapper flex flex-center"
                style="margin-bottom:30px"
              >
                <span
                  class="hmicon icon-jianhao pointer"
                  @click="deleteChild(i)"
                ></span>
              </div>
            </div>
          </div>
          <div>
            <el-form-item
              label="金豆获取比例"
              :prop="'specialTimeModelList.' + i + '.exchangeRatio'"
              :rules="rules.exchangeRatio"
              label-width="190px"
              style="margin-bottom:20px"
            >
              <el-input
                :disabled="type === 'detail' || !!item.sendId"
                v-model.trim="item.exchangeRatio"
                maxlength="20"
                clearable
                size="small"
                placeholder="请输入比例"
                @input="filterGt0OrFixedItem0('exchangeRatio', i)"
              ></el-input>
              %
            </el-form-item>
            <el-form-item
              label-width="108px"
              prop="validatorTime"
              :rules="rules.validatorTime"
              ref="validatorTime"
              style="margin-bottom:20px"
            >
              <hm-date-select
                :isShow="true"
                title="使用"
                :applydate="
                  isArray(ruleForm.applyDate) ? ruleForm.applyDate : []
                "
                :disableDate="isArray(ruleForm.applyDate)"
                :disableEditDate="type === 'detail' || !!item.sendId"
                :ref="'hmDateSelect' + i"
                multipleTime
              ></hm-date-select>
            </el-form-item>
          </div>
        </el-form-item>
      </div>
    </el-form>

    <div class="btn-wrapper flex flex-center">
      <el-button
        size="small"
        type="primary"
        @click="save"
        v-if="type !== 'detail'"
        >确 定</el-button
      >
      <el-button size="small" @click="$router.back(-1)">返 回</el-button>
    </div>
    <el-dialog
      :close-on-click-modal="false"
      :visible.sync="dialogVisible"
      width="1000px"
      title="特殊时段历史记录"
    >
      <div>
        <el-form ref="ruleFormdetail" label-width="100px">
          <div
            v-for="(item, i) in historyList"
            :key="i"
            class="mb20"
            style="border-bottom:1px solid #ddd"
          >
            <div class="flex mb10">
              <div class="mr10" style="font-weight:700;color: #606266;">
                主题名称:
              </div>
              <div>{{ item.name }}</div>
            </div>
            <div class="flex mb10">
              <div class="mr10" style="font-weight:700;color: #606266;">
                金豆获取比例:
              </div>
              <div>{{ item.exchangeRatio }}%</div>
            </div>
            <hm-date-select
              :isShow="true"
              title="使用"
              :applydate="isArray(ruleForm.applyDate) ? ruleForm.applyDate : []"
              :disableDate="false"
              :disableEditDate="true"
              :ref="'hmDateSelectHistory' + i"
              multipleTime
            ></hm-date-select>
          </div>
        </el-form>
      </div>
    </el-dialog>
  </hm-content>
</template>

<script>
import HmDateSelect from "@/components/HmJinDouDateSelect";
export default {
  components: { HmDateSelect },
  data() {
    const validatorFunc = (rule, val, callback) => {
      this.ruleForm.specialTimeModelList.map((v, i) => {
        const {
          runningTimeType,
          ruleDateAndTime,
          ruleDate,
          dateType,
          dateValue,
          dateConfigRange,
          week,
          daysList
        } = this.$refs["hmDateSelect" + i][0];

        // 选择全时段
        if (runningTimeType === "all") {
          if ((ruleDateAndTime && !ruleDateAndTime[0]) || !ruleDateAndTime) {
            return callback(new Error("请选择日期"));
          }
          callback();
          // 选择特定时段
        } else if (runningTimeType === "special") {
          if (dateConfigRange && !dateConfigRange.length) {
            return callback(new Error("请选择使用时间"));
          } else if ((ruleDate && !ruleDate.length) || !ruleDate) {
            return callback(new Error("请选择使用日期"));
          }
          if (dateType === "day") {
            if (!dateValue) {
              return callback(new Error("请输入使用天数"));
            } else callback();
          } else if (dateType === "week") {
            if (week && !week.length) {
              return callback(new Error("请选择使用周"));
            }
            callback();
          } else if (dateType === "month") {
            if (daysList && !daysList.length) {
              return callback(new Error("请选择使用天"));
            }
            callback();
          }
        }
      });
    };
    return {
      historyList: [],
      dialogVisible: false,
      memberGroupList: [],
      ruleList: [],
      ruleForm: {
        name: "",
        sendWayType: "offline",
        exchangeRatio: "",
        levelMin: "",
        ruleId: "",
        groupId: "",
        applyDate: "",
        specialStatus: "no",
        isFirst: 0,
        specialTimeModelList: [
          {
            isFirst: "yes",
            name: "",
            exchangeRatio: "",
            applyDate: "",
            timeStrategyType: ""
          }
        ]
      },
      rules: {
        name: [
          {
            required: true,
            trigger: "change",
            message: "请输入名称"
          }
        ],
        sendWayType: {
          required: true,
          trigger: "change",
          message: "请输入金额"
        },
        exchangeRatio: {
          required: true,
          trigger: "change",
          message: "请输入金豆获取比例"
        },
        levelMin: {
          required: true,
          trigger: "change",
          message: "请输入金豆获取订单门槛"
        },
        ruleId: {
          required: true,
          trigger: "blur",
          message: "请选择关联金豆"
        },
        groupId: {
          required: true,
          trigger: "blur",
          message: "请选择会员群组"
        },
        applyDate: {
          required: true,
          message: "请选择时间",
          trigger: "blur"
        },
        specialStatus: {
          required: true,
          message: "请选择时间",
          trigger: "blur"
        },
        // exchangeRatio: {
        //   required: true,
        //   trigger: "change",
        //   message: "请输入比例"
        // },
        validatorTime: {
          required: true,
          validator: validatorFunc,
          trigger: "blur"
        }
      },
      list: [],
      total: 0,
      currentPage: 1,
      pageSize: 10,
      searchCondition: {},
      disableData: false,
      type: this.$route.query.type,
      sendId: this.$route.query.sendId,
      timeStatus: this.$route.query.timeStatus
    };
  },
  created() {},
  mounted() {
    this.queryMemberGroupList();
    this.queryRuleList();
    if (this.type !== "add") {
      this.queryDetails();
    }
  },
  methods: {
    async detailHistory() {
      const { result } = await this.$store.dispatch(
        "storeGoldBeanSendHistory",
        {
          sendId: this.sendId
        }
      );
      if (result.length) {
        this.dialogVisible = true;
        this.historyList = result;

        this.$nextTick(() => {
          this.historyList.forEach((v, i) => {
            let timeJson = JSON.parse(v.timeJson);
            this.$refs["hmDateSelectHistory" + i][0].ruleDate = [
              v.startTime,
              v.endTime
            ];
            if (v.timeStrategyType === 0) {
              this.$refs["hmDateSelectHistory" + i][0].dateType = "day";
              this.$refs["hmDateSelectHistory" + i][0].dateValue = timeJson.day;
              // timeJson.day = dateValue;
            } else if (v.timeStrategyType === 1) {
              this.$refs["hmDateSelectHistory" + i][0].dateType = "week";
              this.$refs[
                "hmDateSelectHistory" + i
              ][0].week = timeJson.weekList.map(v => v.weekValue);

              // timeJson.weekList = [];
              // week.forEach(v => {
              //   timeJson.weekList.push({
              //     weekValue: v
              //   });
              // });
            } else if (v.timeStrategyType === 2) {
              this.$refs["hmDateSelectHistory" + i][0].dateType = "month";
              this.$refs["hmDateSelectHistory" + i][0].daysList =
                timeJson.monthList;
              // timeJson.monthList = daysList;
            }
          });
        });
      } else {
        this.$message({
          message: "暂无历史记录！",
          type: "warning"
        });
      }
    },
    async queryDetails() {
      const { result } = await this.$store.dispatch(
        "storeGoldBeanSendDetails",
        {
          sendId: this.sendId
        }
      );
      result.specialTimeModelList = result.specialTimeModelList
        ? result.specialTimeModelList
        : [];
      for (let key in result) {
        if (this.ruleForm.hasOwnProperty(key)) {
          this.ruleForm[key] = result[key];
        }
      }
      if (result.specialStatus === "no") {
        this.ruleForm.specialTimeModelList = [
          {
            isFirst: "yes",
            name: "",
            exchangeRatio: "",
            applyDate: "",
            timeStrategyType: ""
          }
        ];
      } else {
        this.ruleForm.isFirst = "";
        setTimeout(() => {
          this.ruleForm.specialTimeModelList.forEach((v, i) => {
            let timeJson = JSON.parse(v.timeJson);

            if (v.isFirst) {
              this.ruleForm.isFirst = i;
            }

            this.$refs["hmDateSelect" + i][0].ruleDate = [
              v.startTime,
              v.endTime
            ];
            if (v.timeStrategyType === 0) {
              this.$refs["hmDateSelect" + i][0].dateType = "day";
              this.$refs["hmDateSelect" + i][0].dateValue = timeJson.day;
              // timeJson.day = dateValue;
            } else if (v.timeStrategyType === 1) {
              this.$refs["hmDateSelect" + i][0].dateType = "week";
              this.$refs["hmDateSelect" + i][0].week = timeJson.weekList.map(
                v => v.weekValue
              );

              // timeJson.weekList = [];
              // week.forEach(v => {
              //   timeJson.weekList.push({
              //     weekValue: v
              //   });
              // });
            } else if (v.timeStrategyType === 2) {
              this.$refs["hmDateSelect" + i][0].dateType = "month";
              this.$refs["hmDateSelect" + i][0].daysList = timeJson.monthList;
              // timeJson.monthList = daysList;
            }
          });
        }, 100);
      }
      this.ruleForm.applyDate = [result.startTime, result.endTime];
    },
    async queryRuleList() {
      const params = {
        pageSize: 99999,
        pageNo: 1,
        useStatus: "yes"
      };
      // const searchCondition = JSON.parse(JSON.stringify(this.searchCondition));
      // Object.assign(params, searchCondition);
      const { code, result } = await this.$store.dispatch(
        "storeGoldBeanRulePage",
        params
      );
      if (code === "0") {
        const { records } = result;
        this.ruleList = records;
      }
    },
    filterGt0OrFixed2(prop) {
      this.ruleForm[prop] = this.ruleForm[prop].replace(/[^\d.]/g, ""); //仅保留数字和"."
      this.ruleForm[prop] = this.ruleForm[prop].replace(/\.{2,}/g, "."); //两个连续的"."仅保留第一个"."
      this.ruleForm[prop] = this.ruleForm[prop]
        .replace(".", "$#*")
        .replace(/\./g, "")
        .replace("$#*", "."); //去除其他"."
      this.ruleForm[prop] = this.ruleForm[prop].replace(
        /^(\d+)\.(\d\d).*$/,
        "$1.$2"
      ); //限制只能输入两个小数
      if (this.ruleForm[prop].indexOf(".") < 0 && this.ruleForm[prop] != "") {
        //首位是0的话去掉
        this.ruleForm[prop] = parseFloat(this.ruleForm[prop]);
      }
    },
    filterGt0OrFixed0(prop) {
      this.ruleForm[prop] = this.ruleForm[prop].replace(/^(0+)/, ""); //过滤0开头
      this.ruleForm[prop] = this.ruleForm[prop].replace(/[^\d]/g, "");
      this.ruleForm[prop] = this.ruleForm[prop]
        .replace(".", "")
        .replace("-", "")
        .replace(",", "");

      this.ruleForm[prop] = new Number(this.ruleForm[prop]);
    },
    filterGt0OrFixedItem0(prop, i) {
      this.ruleForm.specialTimeModelList[i][
        prop
      ] = this.ruleForm.specialTimeModelList[i][prop].replace(/^(0+)/, ""); //过滤0开头
      this.ruleForm.specialTimeModelList[i][
        prop
      ] = this.ruleForm.specialTimeModelList[i][prop].replace(/[^\d]/g, "");
      this.ruleForm.specialTimeModelList[i][
        prop
      ] = this.ruleForm.specialTimeModelList[i][prop]
        .replace(".", "")
        .replace("-", "")
        .replace(",", "");

      this.ruleForm.specialTimeModelList[i][prop] = new Number(
        this.ruleForm.specialTimeModelList[i][prop]
      );
    },
    applyDateChange() {
      if (this.ruleForm.specialStatus === "yes") {
        this.ruleForm.specialTimeModelList.forEach((v, i) => {
          this.$refs["hmDateSelect" + i][0].ruleDate = "";
        });
      }
    },
    isArray(arr) {
      return Object.prototype.toString.call(arr) === "[object Array]";
    },
    deleteChild(index) {
      this.ruleForm.specialTimeModelList.splice(index, 1);
    },
    addItem() {
      this.ruleForm.specialTimeModelList.push({});
    },
    swithRunningTimeType() {
      this.$refs.validatorTime.clearValidate();
    },
    async queryMemberGroupList() {
      const { result } = await this.$store.dispatch("queryMemberGroupList", {
        pageNo: 1,
        pageSize: 9999
      });

      const { records } = result;
      this.memberGroupList = records;
    },
    async save() {
      const valid = await this.$refs.ruleForm.validate();
      if (valid) {
        let params = JSON.parse(JSON.stringify(this.ruleForm));
        if (this.type === "edit") {
          params.sendId = this.sendId;
        }
        params.startTime = this.ruleForm.applyDate[0];
        params.endTime = this.ruleForm.applyDate[1];
        params.specialTimeModelList = [];
        if (params.specialStatus === "yes") {
          this.ruleForm.specialTimeModelList.map((v, i) => {
            const {
              runningTimeType,
              ruleDateAndTime,
              ruleDate,
              dateType,
              dateValue,
              dateConfigRange,
              week,
              daysList
            } = this.$refs["hmDateSelect" + i][0];
            let timeStrategyType = 0;
            let timeJson = {};
            if (dateType === "day") {
              timeStrategyType = 0;
              timeJson.day = dateValue;
            } else if (dateType === "week") {
              timeStrategyType = 1;
              timeJson.weekList = [];
              week.forEach(v => {
                timeJson.weekList.push({
                  weekValue: v
                });
              });
            } else if (dateType === "month") {
              timeStrategyType = 2;
              timeJson.monthList = daysList;
            }

            timeJson.timeList = [];
            dateConfigRange.forEach(v => [
              timeJson.timeList.push({
                startTime: v.promotionStartTime,
                endTime: v.promotionEndTime
              })
            ]);

            params.specialTimeModelList.push({
              timeId: this.type === "add" ? "" : v.timeId,
              isFirst: i === this.ruleForm.isFirst,
              name: v.name,
              exchangeRatio: v.exchangeRatio,
              startTime: ruleDate[0],
              endTime: ruleDate[1],
              timeStrategyType,
              timeJson: JSON.stringify(timeJson)
            });
          });
        }
        let name =
          this.type === "add" ? "addStoreBeanSend" : "editStoreGoldBeanSend";
        await this.$store.dispatch(name, params);
        this.$message({
          type: "success",
          message: "操作成功！"
        });
        this.$router.back(-1);
      } else {
        return;
      }
    },
    async queryList() {
      const params = {
        pageSize: this.pageSize,
        pageNo: this.currentPage
      };
      const searchCondition = JSON.parse(JSON.stringify(this.searchCondition));
      Object.assign(params, searchCondition);
      const { code, result } = await this.$store.dispatch("", params);
      if (code === "0") {
        const { total, records } = result;
        this.list = records;
        this.total = total;
      }
    },
    paging(page) {
      this.currentPage = page;
      this.queryList();
    },
    handleSizeChange(size) {
      this.currentPage = 1;
      this.pageSize = size;
      this.queryList();
    }
  }
};
</script>

<style scoped lang="scss"></style>
